import React from "react";
import ConfidenceLabel from "../../shared/ConfidenceLabel";

const Tab1PremiereConsultation = ({ form, onChange, getConfidence }) => {
  const gc = getConfidence || (() => ({ exists: false }));

  return (
    <div className="om-fields">
      <div className="om-field-group">
        <label>Date de la première consultation <ConfidenceLabel confidence={gc("date_premiere_consultation")} /></label>
        <input
          type="date"
          value={form.date_premiere_consultation ?? ""}
          onChange={(e) => onChange("date_premiere_consultation", e.target.value)}
          style={{ borderColor: gc("date_premiere_consultation").color || undefined }}
        />
      </div>

      <div className="om-field-group">
        <label>Motif de référence ou de consultation <ConfidenceLabel confidence={gc("motif_consultation")} /></label>
        <textarea
          rows={4}
          placeholder="Décrivez le motif de référence ou de consultation..."
          value={form.motif_consultation ?? ""}
          onChange={(e) => onChange("motif_consultation", e.target.value)}
          style={{ borderColor: gc("motif_consultation").color || undefined }}
        />
      </div>
    </div>
  );
};

export default Tab1PremiereConsultation;